module.exports = __webpack_public_path__ + "static/media/vouch4.36cad582.png";